import React from 'react';
import './printable-page.styles.scss';
import ProgressDisplayContainer from '@/components/ADMIN/progress-display/progress-display-container.component';

const PrintablePage = () => {

    function printPage() {
        window.print();
    }
    
    return (
        <div className='printable-page'>
            <div className='printable-content'>
                <div id='print-button'> 
                    <div className="g-space-2"></div>
                    <div className='buttons'>
                        <button 
                            
                            className='g-button'
                            onClick={() => printPage()}
                        >
                            Print Page
                        </button>
                    </div>
                    <div className="g-space-2"></div>
                </div>
                <ProgressDisplayContainer />
            </div>
        </div>
    )
}

export default PrintablePage